var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDistributeHorizontalSpacing = function SvgDistributeHorizontalSpacing(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 2.667,
    height: 5.333,
    fill: "currentColor",
    rx: 0.667,
    transform: "matrix(1 0 0 -1 6.667 10.667)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M4 3.26v9.48c0 .328-.298.593-.667.593-.368 0-.666-.265-.666-.592V3.259c0-.327.298-.592.666-.592S4 2.932 4 3.259M13.333 3.26v9.48c0 .328-.298.593-.666.593S12 13.068 12 12.741V3.259c0-.327.299-.592.667-.592s.666.265.666.592"
  })));
};
export default SvgDistributeHorizontalSpacing;